import { CircularProgress, Grid, TableContainer } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import { SecondaryButton } from '../../../Core/FormInput';
import formatters from '../../../Core/Grid/inputFormatter';
import { getNicolBudgetSalesTargets, setNicolBudgetSalesTargets } from '../../../Core/Service/branch-screen-service';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import '../commonStyle.scss';
import AppContext from '../../../App/AppContext';
import moment from 'moment';

const useStyles = makeStyles({
    table: {
        minWidth: 1250,

        '& .MuiTableCell-root': {
            padding: '10px'
        }
    },
    tableRowStyle: {
        backgroundColor: '#E0E0E0'
    }
});

const MonthShortNameList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function isFiniteCheck(str) {
    return isFinite(str) ? str.toFixed(2) : '0.00';
}

const SalesTargetScreen = (props) => {
    const [targetTypeList, setTargetTypeList] = useState([]);

    const [showCircularLoader, setShowCircularLoader] = useState(true);
    const [calculatedTargetTypeList, setCalculatedTargetTypeList] = useState([]);
    const { showToast } = useContext(AppContext);
    const classes = useStyles();
    const pullSalesTargetGridData = async () => {
        setShowCircularLoader(true);
        let tempTargetTypeList = [
            {
                rowName: 'Retail Units',
                staticID: 1,
                data: []
            },
            {
                rowName: 'Motab Units',
                staticID: 2,
                data: []
            },
            {
                rowName: 'Vehicle Sales',
                staticID: 3,
                data: []
            },
            {
                rowName: 'Vehicle Cost Of Sales',
                staticID: 4,
                data: []
            },
            {
                rowName: 'Vehicle Gross Profit',
                data: []
            },
            {
                rowName: 'Vehicle Gross Profit %',
                data: []
            },
            {
                rowName: 'Vehicle Profit Per Unit',
                data: []
            },
            {
                rowName: 'Accessory Sales',
                staticID: 5,
                data: []
            },
            {
                rowName: 'Accessory Cost Of Sales',
                staticID: 6,
                data: []
            },
            {
                rowName: 'Accessory Gross Profit',
                data: []
            },
            {
                rowName: 'Accessory Gross Profit %',
                data: []
            },
            {
                rowName: 'Accessory Profit Per Unit',
                data: []
            },
            {
                rowName: 'PDI costs',
                staticID: 7,
                data: []
            },
            {
                rowName: 'Bonuses Received',
                staticID: 8,
                data: []
            }
        ];
        let res = await getNicolBudgetSalesTargets(props.yearCode?.id, props.data.departmentID, props.branchID);
        let tempResData = res.data.list || [];

        tempResData.forEach((q) => {
            let objIndex = tempTargetTypeList.findIndex((p) => p.staticID === q.salesTargetTypeID);
            if (objIndex > -1) {
                tempTargetTypeList[objIndex].data.push(q);
            }
        });

        tempTargetTypeList.forEach((r) => {
            let list2 = MonthShortNameList.map((m) => {
                let obj = r.data.find((p) => moment(p.salesTargetDate).format('DD-MMM-YYYY').includes(`${m}`));
                if (obj) {
                    return obj;
                } else {
                    return {
                        salesTargetAmount: 0,
                        salesTargetBranchID: props.branchID,
                        salesTargetDate: moment(`01/${m}/${props.yearCode?.id}`).format('DD-MMM-YYYY'),
                        salesTargetDepartmentID: props.data.departmentID,
                        salesTargetID: null,
                        salesTargetTypeID: r.staticID
                    };
                }
            });
            r.data = list2;
        });

        setTargetTypeList(tempTargetTypeList);
        setShowCircularLoader(false);
    };

    useEffect(() => {
        pullSalesTargetGridData();
    }, [props.yearCode?.id]);

    useEffect(() => {
        if (targetTypeList.length > 0) {
            let tempArr = [...targetTypeList];
            let RetailUnitsData = tempArr[0].data;
            let VehicleSalesData = tempArr[2].data;
            let VehicleCostOfSalesData = tempArr[3].data;
            let AccessorySalesData = tempArr[7].data;
            let AccessoryCostOfSalesData = tempArr[8].data;
            let VehicleGrossProfit = [];
            let VehicleGrossProfitPer = [];
            let VehicleProfitPerUnit = [];
            let AccessoryGrossProfit = [];
            let AccessoryGrossProfitPer = [];
            let AccessoryProfitPerUnit = [];

            //Gross profit =  sales - cost of sales
            //Gross profit % =  Gross profit /  sales
            //Gross profit per unit =  Gross profit /  retail unit

            MonthShortNameList.forEach((p, i) => {
                let tempGrossProfit = isFiniteCheck(VehicleSalesData[i]?.salesTargetAmount - VehicleCostOfSalesData[i]?.salesTargetAmount);
                let tempGrossProfitPercentage = isFiniteCheck((tempGrossProfit / VehicleSalesData[i]?.salesTargetAmount) * 100);
                let tempGrossProfitPerUnit = isFiniteCheck(tempGrossProfit / RetailUnitsData[i]?.salesTargetAmount);
                VehicleGrossProfit.push({ salesTargetAmount: tempGrossProfit });
                VehicleGrossProfitPer.push({ salesTargetAmount: tempGrossProfitPercentage });
                VehicleProfitPerUnit.push({ salesTargetAmount: tempGrossProfitPerUnit });
                let tempAccessoryGrossProfit = isFiniteCheck(AccessorySalesData[i]?.salesTargetAmount - AccessoryCostOfSalesData[i]?.salesTargetAmount);
                let tempAccessoryGrossProfitPercentage = isFiniteCheck((tempAccessoryGrossProfit / AccessorySalesData[i]?.salesTargetAmount) * 100);
                let tempAccessoryGrossProfitPerUnit = isFiniteCheck(tempAccessoryGrossProfit / RetailUnitsData[i]?.salesTargetAmount);
                AccessoryGrossProfit.push({ salesTargetAmount: tempAccessoryGrossProfit });
                AccessoryGrossProfitPer.push({ salesTargetAmount: tempAccessoryGrossProfitPercentage });
                AccessoryProfitPerUnit.push({ salesTargetAmount: tempAccessoryGrossProfitPerUnit });
            });
            tempArr[4].data = VehicleGrossProfit;
            tempArr[5].data = VehicleGrossProfitPer;
            tempArr[6].data = VehicleProfitPerUnit;
            tempArr[9].data = AccessoryGrossProfit;
            tempArr[10].data = AccessoryGrossProfitPer;
            tempArr[11].data = AccessoryProfitPerUnit;

            tempArr.forEach((t) => {
                let DataTotal = 0;
                t.data.forEach((q) => {
                    DataTotal += +q.salesTargetAmount;
                });
                t.allSalesTargetAmount = isFiniteCheck(DataTotal);
            });

            setCalculatedTargetTypeList(tempArr);
        }
    }, [targetTypeList]);

    const gridInputChangeHandler = (index, typeID) => (e) => {
        let tempList = [...targetTypeList];
        let objIndex = tempList.findIndex((x) => x.staticID === typeID);
        tempList[objIndex].data[index] = {
            ...tempList[objIndex].data[index],
            salesTargetAmount: +e.target.value,
            salesTargetTypeID: typeID,
            isChanged: true
        };
        setTargetTypeList(tempList);
    };

    const InputWrapper = (index, typeID, value) => {
        return (
            <input type="number" name={typeID} onChange={gridInputChangeHandler(index, typeID)} value={value} className="pa-4" style={{ textAlign: 'right' }} />
        );
    };

    const handleSubmit = async () => {
        let tempTargetTypeList = [...targetTypeList];
        let data = [];
        tempTargetTypeList.forEach((f) => {
            let tempData = f.data.filter((j) => j.isChanged).map(({ salesTargetDepartmentID, salesTargetBranchID, isChanged, ...q }) => ({ ...q }));
            data = [...data, ...tempData];
        });
        let filterPostData = {
            BranchID: props.branchID,
            SalesTargetDepartmentID: props.data.departmentID,
            SalesTargets: data
        };

        let res = await setNicolBudgetSalesTargets(filterPostData);
        if (res.success) {
            showToast('Sales Target Save Successfully');
            pullSalesTargetGridData();
        }
    };

    return (
        <Grid container item style={{ paddingTop: '10px' }} justifyContent="center">
            <Grid container item spacing={2} justifyContent="space-between">
                <Grid xs={8} item></Grid>
                <Grid xs={4} container item spacing={2} alignItems="center" justifyContent="flex-end">
                    <Grid item xs={4}>
                        <SecondaryButton className="setFullWidth" onClick={handleSubmit}>
                            Submit
                        </SecondaryButton>
                    </Grid>
                    <Grid item xs={4}>
                        <SecondaryButton className="setFullWidth">Cancel</SecondaryButton>
                    </Grid>
                </Grid>
            </Grid>
            {showCircularLoader ? (
                <Grid item>
                    <CircularProgress />
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <TableContainer component={Paper} style={{ maxHeight: 'calc(100vh - 290px)' }} className="input-Number-remove-spinners">
                        <Table className={classes.table} stickyHeader aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell width={170}></TableCell>
                                    {MonthShortNameList.map((p) => {
                                        return (
                                            <TableCell align="right" key={p}>
                                                {p}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell width={100} align="right">
                                        Total
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {calculatedTargetTypeList.map((t) => {
                                    return (
                                        <TableRow className={t.staticID ? {} : classes.tableRowStyle}>
                                            <TableCell component="th" scope="row">
                                                {t.rowName}
                                            </TableCell>

                                            {t.data.map((p, i) => {
                                                return t.staticID ? (
                                                    <TableCell align="right">{InputWrapper(i, t.staticID, p.salesTargetAmount)}</TableCell>
                                                ) : (
                                                    <TableCell align="right">{p.salesTargetAmount}</TableCell>
                                                );
                                            })}

                                            {t.staticID ? <TableCell align="right">{formatters.ToFixedSeparator(+t.allSalesTargetAmount)}</TableCell> : ''}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            )}
        </Grid>
    );
};

export default SalesTargetScreen;
